import React from 'react';
import { Redirect } from 'react-router-dom';

import { useAuthContext } from '@/contexts';
import { getRootPathRedirection } from '@/constants/paths';

function LoggedUserRed(ComposedComponent, extraInfo) {
  // Return a new component that can use hooks
  const LoginAccessCtrl = (props) => {
    const { profile } = useAuthContext();
    const redirectionPath = getRootPathRedirection(profile?.market);

    const userDetail =
      JSON.parse(localStorage.getItem('okta-token-storage')) || '{}';

    const hasToken = userDetail.idToken && userDetail.accessToken;

    if (!hasToken) {
      localStorage.clear();
      // Pass router props and any extra info down to the wrapped component
      return <ComposedComponent {...props} {...extraInfo} />;
    }

    return <Redirect to={redirectionPath} />;
  };

  return LoginAccessCtrl;
}

export default LoggedUserRed;
